import * as types from '@store/types'
import graphQL from '@queries'
import BannersQuery from '@queries/Banners'

const state = {
  banners: [],
  banners_result: [],
  last_category: '',
  scroll_position: ''
}

const getters = {
  [types.BANNERS]: ({ banners }) => banners,
  [types.LAST_CATEGORY]: ({ last_category }) => last_category,
  [types.SCROLL_POSITION]: ({ scroll_position }) => scroll_position,
  [types.BANNERS_RESULT]: ({ banners_result }) => banners_result
}

const mutations = {
  [types.BANNERS]: (state, payload) => {
    state.banners = payload
  },
  [types.BANNERS_RESULT]: (state, payload) => {
    state.banners_result = payload
  },
  [types.LAST_CATEGORY]: (state, payload) => {
    state.last_category = payload
  },
  [types.SCROLL_POSITION]: (state, payload) => {
    state.scroll_position = payload
  }
}

const actions = {
  [types.BANNERS]: async ({ commit }) => {
    const response = await graphQL(BannersQuery)
    const banners = (response.data.data || {}).banners || []
    commit(types.BANNERS, banners)
  },
  [types.BANNERS_RESULT]: async ({ commit }) => {
    const response = await graphQL(BannersQuery, { result: true })
    const banners = (response.data.data || {}).bannerResult || []
    commit(types.BANNERS_RESULT, banners)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/banner.js